export default {
  title: 'Información de contacto',
  form: {
    customer_first_name: {
      placeholder: 'Nombre',
    },
    customer_last_name: {
      placeholder: 'Apellidos',
    },
    customer_email: {
      placeholder: 'Correo electrónico',
    },
    customer_phone_number: {
      placeholder: 'Número de teléfono',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Por favor, introduce tu nombre',
    },
    customer_last_name: {
      required: 'Por favor, introduce tus apellidos',
    },
    customer_email: {
      required: 'Por favor, introduce tu correo electrónico',
    },
    customer_phone_number: {
      required: 'Por favor, introduce tu número de teléfono',
    },
  },
};
